import { modal } from "../../functions/modal";
import axios from '../../helpers/axiosConfig';
import { el } from "../../functions/create-element";
export function login() {
    const widget = document.querySelector('.login-widget');
    if (!widget)
        return;
    const init = (widget) => {
        const form = widget.querySelector('[data-ajax-submit="true"]');
        if (!form) {
            return;
        }
        const url = form.getAttribute('data-url');
        const getMessagesNode = (messages) => {
            const msgContainer = el('div', {});
            messages.forEach((message) => {
                const msgEl = el('p', {}, message);
                msgContainer.appendChild(msgEl);
            });
            return msgContainer;
        };
        form.addEventListener('submit', async (e) => {
            e.preventDefault();
            const loginModal = document.querySelector('.login-modal');
            const closeLoginModal = () => {
                loginModal.classList.remove('open');
                setTimeout(() => {
                    loginModal.style.display = 'none';
                }, 300);
            };
            const { username: { value: username }, password: { value: password }, remember: rememberInputs, login: submitBtn } = e.target.elements;
            const { checked } = Array.from(rememberInputs).find((input) => input.type === 'checkbox');
            submitBtn.textContent = "Trwa logowanie...";
            submitBtn.disabled = true;
            try {
                const response = await axios.post(url, {
                    username,
                    password,
                    remember: checked ? 1 : 0
                });
                const msgContainer = getMessagesNode(response.data.messages);
                closeLoginModal();
                setTimeout(() => {
                    modal(__('Sukces!'), msgContainer, 'icon--info-alt');
                    location.reload();
                }, 300);
            }
            catch (err) {
                const msgContainer = getMessagesNode(err.response.data.messages);
                closeLoginModal();
                setTimeout(() => modal(__('Błąd logowania'), msgContainer, 'icon--alert-alt', 'error'), 300);
                submitBtn.textContent = "Zaloguj";
                submitBtn.disabled = false;
            }
            finally {
                form.reset();
            }
        });
    };
    init(widget);
}
